export default __webpack_public_path__ + "static/media/icon-content.b0843264.svg";